import 'react-app-polyfill/ie11';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { BrowserRouter , Switch, Route } from 'react-router-dom'
import ScrollToTop from './ScrollToTop';
import './patches/primereact-dropdown-touch-fix';
import POSApp from '../src/POS/POSApp';

import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import thunk from 'redux-thunk';

import AuthReducer from './store/reducers/auth';
import MasterReducer from './store/reducers/master';
import KeywordReducer from './store/reducers/keyword';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const rootReducer = combineReducers({
    auth : AuthReducer,
    master: MasterReducer,
    keyword: KeywordReducer,
});

const store = createStore(rootReducer, composeEnhancers(
    applyMiddleware(thunk)
));

const path = window.location.pathname;

const isPOS = path.startsWith("/pos/");


// ReactDOM.render(
//     <Provider store={store}>
//         <BrowserRouter to="/">
//             <ScrollToTop>
//                     {isPOS ? <POSApp /> : <App />}
//             </ScrollToTop>
//         </BrowserRouter>
//     </Provider>,
//     document.getElementById('root')
// );

ReactDOM.render(
    <Provider store={store}>
        <BrowserRouter>
            <ScrollToTop>
                <Switch>
                    <Route
                        path="/pos/"
                        component={POSApp}
                    />

                    <Route
                        path="/"
                        component={App}
                    />
                </Switch>
            </ScrollToTop>
        </BrowserRouter>
    </Provider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
//serviceWorker.unregister();